import DirectDealActiveIcon from '~/assets/direct_deal_active.png';
import DirectDealInactiveIcon from '~/assets/direct_deal_inactive.png';
import AdXDealActiveIcon from '~/assets/adx_deal_active.png';
import AdXDealInactiveIcon from '~/assets/adx_deal_inactive.png';
import NetworkLineItemInactiveIcon from '~/assets/network_line_item_inactive.png';
import NetworkLineItemActiveIcon from '~/assets/network_line_item_active.png';
import InhousePromotionActiveIcon from '~/assets/inhouse_promotion_active.png';
import InhousePromotionInactiveIcon from '~/assets/inhouse_promotion_inactive.png';
import ActiveIcon from '~/assets/active.svg';
import ReachedIcon from '~/assets/reached.svg';
import ScheduledIcon from '~/assets/scheduled.svg';
import EndingIcon from '~/assets/ending.svg';
import { createElement } from 'react';
import { SvgIcon } from '@mui/material';

const DEMAND_OVERVIEW_TAB_IDS = {
  DIRECT_DEALS: 'directDeals',
  ADX_DEALS: 'adxDeals',
  NETWORK_LINE_ITEMS: 'networkLineItems',
  INHOUSE_PROMOTIONS: 'inhousePromotions',
};

const DEMAND_OVERVIEW_DEFAULT_TAB_ID = DEMAND_OVERVIEW_TAB_IDS.DIRECT_DEALS;

const DEMAND_OVERVIEW_TABS = [
  {
    id: DEMAND_OVERVIEW_TAB_IDS.DIRECT_DEALS,
    createUrl: 'create-direct-deal',
    listingUrl: '',
    label: 'Direct Deals',
    activeIconPath: DirectDealActiveIcon,
    inactiveIconPath: DirectDealInactiveIcon,
  },
  {
    id: DEMAND_OVERVIEW_TAB_IDS.ADX_DEALS,
    createUrl: 'create-adx-deal',
    listingUrl: 'adx-deals',
    label: 'AdX Deals',
    activeIconPath: AdXDealActiveIcon,
    inactiveIconPath: AdXDealInactiveIcon,
  },
  {
    id: DEMAND_OVERVIEW_TAB_IDS.NETWORK_LINE_ITEMS,
    createUrl: 'create-network-line-item',
    listingUrl: 'network-line-items',
    label: 'Network Line Items',
    activeIconPath: NetworkLineItemActiveIcon,
    inactiveIconPath: NetworkLineItemInactiveIcon,
  },
  {
    id: DEMAND_OVERVIEW_TAB_IDS.INHOUSE_PROMOTIONS,
    createUrl: 'create-inhouse-promotion',
    listingUrl: 'inhouse-promotions',
    label: 'Inhouse Promotions',
    activeIconPath: InhousePromotionActiveIcon,
    inactiveIconPath: InhousePromotionInactiveIcon,
  },
];

const DEAL_METRIC_GROUPS = [
  {
    id: 'active',
    title: 'Active',
    icon: createElement(SvgIcon, {
      component: ActiveIcon,
      inheritViewBox: true,
    }),
    metrics: [{ id: 'campaigns', label: 'Campaigns' }],
  },
  {
    id: 'reached',
    title: 'Reached',
    icon: createElement(SvgIcon, {
      component: ReachedIcon,
      inheritViewBox: true,
    }),
    metrics: [{ id: 'todayLimit', label: 'Today Limit' }],
  },
  {
    id: 'scheduled',
    title: 'Scheduled',
    icon: createElement(SvgIcon, {
      component: ScheduledIcon,
      inheritViewBox: true,
    }),
    metrics: [
      { id: 'paused', label: 'Paused' },
      { id: 'today', label: 'Today' },
      { id: 'next7Days', label: 'Next 7 Days' },
    ],
  },
  {
    id: 'ending',
    title: 'Ending',
    icon: createElement(SvgIcon, {
      component: EndingIcon,
      inheritViewBox: true,
    }),
    metrics: [
      { id: 'today', label: 'Today' },
      { id: 'next3Days', label: 'Next 3 Days' },
      { id: 'next7Days', label: 'Next 7 Days' },
    ],
  },
];

const DEMAND_OVERVIEW_METRIC_GROUPS_BY_TAB = {
  [DEMAND_OVERVIEW_TAB_IDS.DIRECT_DEALS]: DEAL_METRIC_GROUPS,
  [DEMAND_OVERVIEW_TAB_IDS.ADX_DEALS]: DEAL_METRIC_GROUPS,
  [DEMAND_OVERVIEW_TAB_IDS.NETWORK_LINE_ITEMS]: [
    {
      id: 'active',
      title: 'Active',
      tone: 'success',
      icon: createElement(SvgIcon, {
        component: ActiveIcon,
        inheritViewBox: true,
      }),
      metrics: [{ id: 'lineItems', label: 'Campaigns' }],
    },
  ],
  [DEMAND_OVERVIEW_TAB_IDS.INHOUSE_PROMOTIONS]: DEAL_METRIC_GROUPS,
};

const DEMAND_OVERVIEW_TONE_STYLES = {
  success: {
    color: '#00a65a',
    icon: 'checkCircle',
  },
  warning: {
    color: '#ff9800',
    icon: 'trendingUp',
  },
  info: {
    color: '#2f80ed',
    icon: 'event',
  },
  error: {
    color: '#ff375f',
    icon: 'restart',
  },
};

export {
  DEMAND_OVERVIEW_DEFAULT_TAB_ID,
  DEMAND_OVERVIEW_METRIC_GROUPS_BY_TAB,
  DEMAND_OVERVIEW_TAB_IDS,
  DEMAND_OVERVIEW_TABS,
  DEMAND_OVERVIEW_TONE_STYLES,
};
